export const OFFER_REVIEW_PATH = '/review';
export const VIEW_OFFERS_PATH = '/view-offers';
export const OFFER_DESTINATION_PATH = '/offer-destination';
export const OFFER_DATES_PATH = '/dates';
export const OFFER_ELIGIBILITY_PATH = '/eligibility';
export const OFFER_CONTACT_INFO_PATH = '/contact-info';
export const OFFER_CONFIRMATION_PATH = '/confirmation';

export const PIN: string = 'pin';
export const LOC: string = 'loc';

export const TERMS_OF_USE_PATH = '/terms-of-use';
export const PRIVACY_PATH = '/privacy';
export const STATE_AND_LEGAL_DISCLOSURES_PATH = '/state-and-legal-disclosures';
export const ACCESSIBILITY_STATEMENT_PATH = '/accessibility-statement/';

export const CONFIRM = 'confirm';

export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const ADDRESS_LINE = 'addressLine1';
export const CITY = 'city';
export const POSTAL_CODE = 'postalCode';
export const EMAIL = 'email';
export const PHONE = 'phone';

export const FIRST_NAME2 = 'firstName2';
export const LAST_NAME2 = 'lastName2';
export const ADDRESS_LINE2 = 'addressLine2';
export const CITY2 = 'city2';
export const STATEPROVINCE2 = 'stateProvince2';
export const POSTAL_CODE2 = 'postalCode2';
export const EMAIL2 = 'email2';
export const PHONE2 = 'phone2';

export const SPOUSE_FIRST_NAME = 'spouseFirstName';
export const SPOUSE_LAST_NAME = 'spouseLastName';

export const TourRequired = 'TR';

export const NA = 'n/a';
export const NACaps = 'N/A';

export const none = 'none';
export const B4 = 'B4';

export const PERSON = 'person';
export const TELEPHONE = 'telephonic';
